import React, { PropsWithChildren } from 'react';
import { HtmlProps } from '../../../../types/HtmlProps';

type WidgetHeaderProps = { invisible?: boolean } & PropsWithChildren<HtmlProps>;

export function WidgetHeader({ children, invisible, ...props }: WidgetHeaderProps) {
  const className = ['widget-header__header'];

  if (invisible) {
    className.push('invisible');
  }

  return (
    <header className={className.join(' ')} {...props}>
      {children}
    </header>
  );
}
